export const related = [
  '/quests/into-the-sinkhole',
  '/guides/build-power',
  '/quests',
];
export const quickAnswer =
  'After Arish’s Briefing: reroute the stations, reach the vanished station, calibrate Platform A before Platform B, then speak to Dr. Florez.';
export const sourceIds = ['powerpyx-power-lines', 'powerpyx-quests'];

## Power Lines Requirements

This Contain the Crisis mission follows Arish’s Briefing.

## Station Rerouting Overview

Place calibration units on the marked positions and activate each station's tuning device. At Factory, the units form a straight line. At East Park, clear the mold covering placement marks.

## Platform A Calibration

Power both boxes at Platform B to reach A. Use A's power to open the upstairs gate and retrieve a unit. Remove the power before clearing regrowing mold; place both units and activate A.

## Platform B Calibration

Grow mold with power on. Remove power, clear the side placement areas, and preserve the middle mold bridging the wires. Place the two units and activate B.

## Common Stuck Points

A must be complete before B. If the central conductive mold was destroyed, regrow it with power. If mold blocks a unit placement, clear it while unpowered.

## What Unlocks Next

Clear the remaining enemies and speak to Dr. Florez. Check the journal for outstanding Contain the Crisis objectives, including [Into the Sinkhole](/quests/into-the-sinkhole).
